import { Filter, SearchParams } from '@shared/types/searchParams'

const DEFAULT_SEARCH_PARAMS: SearchParams = {
	limit: 10,
	start: 0,
	page: 0,
	filter: [],
	sort: [],
	independent_fields: {},
}

const DEFAULT_FILTER_PARAMS: Filter = {
	property: 'id',
	value: '1',
	disableOnEmpty: false,
	operator: 'eq',
	independent: false,
}

export const generateFilters = (params: Partial<Filter> = {}): Filter => {
	return { ...DEFAULT_FILTER_PARAMS, ...params }
}

export const createSearchParams = (params: Partial<SearchParams> = {}): SearchParams => {
	return {
		...DEFAULT_SEARCH_PARAMS,
		...params,
	}
}
